import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {CHECK__24} from '@homeaway/svg-defs/lib/defs/CHECK__24';
import {SVGIcon} from '@homeaway/react-svg';

export class IconBullet extends React.PureComponent {
    static propTypes = {
        fillColor: PropTypes.string,
        icon: PropTypes.node,
        text: PropTypes.string,
    };

    static defaultProps = {
        icon: CHECK__24,
    };

    render() {
        const bulletClassName = classNames('li__icon', this.props.fillColor);

        return (
            <li role="listitem" className="IconBullet li--flex-icon">
                <span role="none" aria-hidden="true">
                    <SVGIcon
                        role="none"
                        aria-hidden="true"
                        markup={this.props.icon}
                        className={bulletClassName}
                        useFill
                    />
                </span>
                <span className="li__content">{this.props.text}</span>
            </li>
        );
    }
}
